import { StatSeries } from '@/models/stats.ts'

/**
 * Categorical palette for the statistics charts.
 *
 * Validated for colour-vision deficiency in the order below (adjacent pairs are
 * what a stack puts next to each other) against a white card surface. Teal sits
 * slightly under 3:1 contrast, which the always-present legend and the "Alle
 * Werte im Detail" table make up for — do not drop either without re-checking.
 *
 * Colour follows the series, never its position: a filtered-away series must not
 * repaint the others, so the map is keyed by the group key the API sends.
 */
export const STAT_GROUP_COLORS: Record<string, string> = {
  views: '#2563EB',
  shares: '#D97706',
  app_installs: '#14B8A6',
  downloads: '#BE185D',
  contacts: '#7C3AED',
  selections: '#65A30D',
}

/** Same hues in the same order, for series that are not one of the known groups. */
export const STAT_FALLBACK_COLORS = [
  '#2563EB', '#D97706', '#14B8A6', '#BE185D', '#7C3AED', '#65A30D',
]

/** Neutral gray for anything past the palette — never a generated hue. */
const STAT_OVERFLOW_COLOR = '#6B7280'

export function colorForSeries(series: StatSeries, index: number): string {
  const known = STAT_GROUP_COLORS[series.key]
  if (known) return known
  return STAT_FALLBACK_COLORS[index] ?? STAT_OVERFLOW_COLOR
}
